import Axios from "axios";

import {
    getDataWithComp,
    getAlert,
    parseCurrency
} from "./SamuiUtils";

import {
    formatDateTime,
    formatThaiDateUiToDate,
    getCreateDateTime
} from "./DateUtils";

export async function manageWhArPaymentData(
    arId, // AR_ID ของลูกค้านั้นๆ
    arCode, // AR_Code ของสิ่งนั้นๆ
    arName, // ชื่อลูกค้าคนนั้นๆ
    whId, // WarehouseID (Default ไว้ที่ 0 เสมอ)
    docType, // ประเภท เช่น AI/AO
    payAmt, // ค่าจำนวนเงิน
    docId, // ไอดีเอกสาร
    docNo, // เลขเอกสาร
    docNoRef, // เลขเอกสารอ้างอิง
    stcRemark, // หมายเหตุ
    payType // ช่องทางชำระเงิน
) {
    try {
        // Find WH_ARPAYMENT_Onhand By comp_id, item_id, wh_id
        let findItemOnHand = await getDataWithComp("WH_ARPAYMENT_Onhand", `AND Item_Id = ${arId} AND WH_Id = ${whId}`);

        // ถ้าเจอให้ Update WH_ARPAYMENT_Onhand แต่ถ้าไม่เจอให้ Insert WH_ARPAYMENT_Onhand
        if (findItemOnHand.length > 0) {
            // UPDATE WH_ARPAYMENT_Onhand
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/update-wh-ar-payment-on-hand`, {
                last_qty: payAmt,
                item_on_hand: parseCurrency(payType) === 4 ? findItemOnHand[0].Item_Onhand : parseCurrency(await calculateNewQty(docType, findItemOnHand[0].Item_Onhand, payAmt)),
                last_stc_seq: formatDateTime(new Date()),
                last_stc_date: formatThaiDateUiToDate(getCreateDateTime()) + ".000",
                item_id: arId,
                item_on_hand_credit: parseCurrency(payType) === 4 ? parseCurrency(await calculateNewQty(docType, findItemOnHand[0].Item_Onhand_Credit, payAmt)) : findItemOnHand[0].Item_Onhand_Credit,
                wh_id: whId,
                comp_id: window.localStorage.getItem('company')
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        } else {
            // INSERT WH_ARPAYMENT_Onhand
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/insert-wh-ar-payment-onhand`, {
                item_id: arId,
                item_code: arCode,
                item_name: arName,
                item_barcode: null,
                last_qty: payAmt,
                item_on_hand: parseCurrency(payType) === 4 ? parseCurrency("0") : payAmt > 0 ? -Math.abs(payAmt) : payAmt,
                wh_id: whId,
                zone_id: parseCurrency("1"),
                lt_id: parseCurrency("1"),
                last_stc_seq: formatDateTime(new Date()),
                last_stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                comp_id: window.localStorage.getItem('company'),
                item_last_onhand: null,
                item_on_hand_credit: parseCurrency(payType) === 4 ? payAmt > 0 ? -Math.abs(payAmt) : payAmt : parseCurrency("0")
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        }

        // ทำการ Insert WH_ARPAYMENT_STC ทุกกรณี
        // Find TOP(1) WH_ARPAYMENT_STC By item_id, wh_id,comp_id ORDER BY STC_SEQ DESC; 
        // => ต้องการ STC_Balance เพื่อมาบวกกับจำนวนรับแล้ว INSERT ใหม่
        let findItemStc = await getDataWithComp("WH_ARPAYMENT_STC", `AND Item_Id = ${arId} AND WH_Id = ${whId} ${parseCurrency(payType) === 4 ? "AND Paid_Type = 4" : "AND (Paid_Type <> 4 OR Paid_Type IS NULL)"} ORDER BY STC_SEQ DESC`);

        //ถ้าเจอให้ Insert WH_ARPAYMENT_STC เอาค่าเดิมมากบวก แต่ถ้าไม่เจอให้ Insert WH_ARPAYMENT_STC เอา 0 + ค่าใหม่
        if (findItemStc.length > 0) {
            // Insert WH_ARPAYMENT_STC เอาค่าเดิมมากบวก
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/insert-wh-ar-payment-stc`, {
                item_id: arId,
                item_code: arCode,
                item_name: arName,
                doc_type: docType,
                ref_balance: parseCurrency("0"),
                stc_qty: payAmt,
                stc_balance: parseCurrency(await calculateNewQty(docType, findItemStc[0].STC_Balance, payAmt)),
                stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                stc_by: window.localStorage.getItem('emp_id'),
                comp_id: window.localStorage.getItem('company'),
                doc_id: docId,
                doc_no: docNo,
                doc_noref: docNoRef,
                stc_remark: stcRemark,
                stc_seq: formatDateTime(new Date()),
                wh_id: whId,
                zone_id: parseCurrency("1"),
                lt_id: parseCurrency("1"),
                paid_type: parseCurrency(payType)
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        } else {
            // Insert WH_ARPAYMENT_STC เอา 0 + ค่าใหม่
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/insert-wh-ar-payment-stc`, {
                item_id: arId,
                item_code: arCode,
                item_name: arName,
                doc_type: docType,
                ref_balance: parseCurrency("0"),
                stc_qty: payAmt,
                stc_balance: parseCurrency(await calculateNewQty(docType, parseCurrency("0"), payAmt)),
                stc_date: formatThaiDateUiToDate(getCreateDateTime()),
                stc_by: window.localStorage.getItem('emp_id'),
                comp_id: window.localStorage.getItem('company'),
                doc_id: docId,
                doc_no: docNo,
                doc_noref: docNoRef,
                stc_remark: stcRemark,
                stc_seq: formatDateTime(new Date()),
                wh_id: whId,
                zone_id: parseCurrency("1"),
                lt_id: parseCurrency("1"),
                paid_type: parseCurrency(payType)
            }, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' }
            });
        }
    } catch (error) {
        getAlert("FAILED", error)
        return null;
    }
}

export async function calculateNewQty(docType, currentQty, payAmt) {
    let newQty;

    switch (docType) {
        case 'IN':
        case 'AI':
        case 'TI':
        case 'CC':
            newQty = parseCurrency(currentQty) + parseCurrency(payAmt);
            break;
        case 'OUT':
        case 'AO':
        case 'TO':
            let newPayAmt = payAmt > 0 ? -Math.abs(payAmt) : payAmt;
            newQty = parseCurrency(currentQty) + parseCurrency(newPayAmt);
            break;
        default:
            throw new Error(`Unsupported docType: ${docType}`);
    }

    return newQty;
}

export async function setRemarkByPaymentType(paymentType) {
    let remark;

    switch (paymentType) {
        case 1: // 1 เงินสด
            remark = "เงินสด";
            break;
        case 2:  // 2 เงินโอน
            remark = "เงินโอน";
            break;
        case 3: // 3 เช็ค
            remark = "เช็ค";
            break;
        case 4: // 4 เครดิต
            remark = "เครดิต";
            break;
        case 5: // 5 ค้างจ่าย
            remark = "ค้างจ่าย";
            break;
        case 8: // 8 อื่นๆ ระบุ
            remark = "อื่นๆ";
            break;
        default:
            throw new Error(`Unsupported PaymentType: ${paymentType}`);
    }

    return remark;
}